import { useTranslation } from '@/i18n'
import { AKEERA_AVATAR_SRC } from './constants'

/**
 * The circular avatar button in the page header. A plain inline control: it is
 * laid out by the header's action cluster that renders it (see
 * HelpAgentLauncherSlot), so it carries no positioning and no z-index.
 *
 * It is a TOGGLE, not a one-way open. The avatar stays put while the panel is
 * open and wears a brand ring to say so (Putra's design) — it is the only
 * thing on screen that says where the panel came from, and a control that
 * vanishes the moment you use it reads as a glitch. Clicking again closes.
 *
 * `size-9` in a 60px header leaves 12px above and below; `ring-offset-2` gives
 * the ring the gap the design shows between it and the photo. No ring when
 * closed: the old white one existed to separate the button from the page
 * content it floated over, and on a white header it says nothing.
 */
const HelpAgentLauncher = ({
  isOpen,
  onToggle,
}: {
  isOpen: boolean
  onToggle: () => void
}) => {
  const { t } = useTranslation('help_agent')
  return (
    <button
      type="button"
      aria-label={isOpen ? t('launcher.close') : t('launcher.open')}
      aria-expanded={isOpen}
      onClick={onToggle}
      className={`size-9 shrink-0 overflow-hidden rounded-full transition-transform hover:scale-105 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${
        isOpen ? 'ring-2 ring-brand ring-offset-2 ring-offset-white dark:ring-offset-dark-card' : ''
      }`}
    >
      <img src={AKEERA_AVATAR_SRC} alt="" className="size-full object-cover" />
    </button>
  )
}

export default HelpAgentLauncher
